import {
  CLEAR_LINK_CACHE,
  GET_LINK,
  GET_LINK_FAILED,
  RECEIVE_LINK,
} from './actions';

const initialState = {
  /*unitUrl: {},
  unitQuestionnaires: {},
  instructions: [{keys: ["common"], values: ["Ohje", "http://tays.fi"]}]*/
  Toimipistetiedot: {},
  Logot: {},
  Ohjeet: {},
};

const addToData = (codeSet, key, data) => {
  if (codeSet == null) {
    codeSet = {};
  }
  if (data != null && data[0] != null) {
    codeSet[key] = data;
  }
  return codeSet;
};

const linkkipalvelu = (state = initialState, action) => {
  const { key, type, codeSet, data } = action;
  switch (type) {
    case GET_LINK: {
      return {
        ...state,
        [codeSet]: addToData(state[codeSet], key, 'fetching'),
      };
    }
    case GET_LINK_FAILED: {
      return {
        ...state,
        [codeSet]: addToData(state[codeSet], key, 'error'),
      };
    }
    case RECEIVE_LINK: {
      return {
        ...state,
        [codeSet]: addToData(state[codeSet], key, [data]),
      };
    }
    case CLEAR_LINK_CACHE: {
      return {
        ...state,
        [codeSet]: {},
      };
    }
    default:
      return state;
  }
};

export { linkkipalvelu };
